import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { piarcResearchAreas } from "@/mocks/piarcData";

export default function PiarcResearchAreas() {
  return (
    <section id="research" className="bg-tie-grey-light py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Research Domains
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-tie-text-primary leading-tight">
                Where PIARC Creates Impact
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                Research circles span the full production spectrum — from wet processing to automation, sustainability to human factors. Each area produces implementable outputs.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {piarcResearchAreas.map((area, index) => (
              <ScrollReveal key={area.name} delay={index * 80}>
                <div className="group h-full p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark hover:border-tie-teal/30 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-3 md:mb-4">
                    <div className="w-10 h-10 rounded-lg bg-tie-teal flex items-center justify-center shrink-0">
                      <i className={`${area.icon} text-white text-base`} />
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-tie-text-primary">
                      {area.name}
                    </h3>
                  </div>
                  <div className="space-y-2">
                    {area.examples.map((example) => (
                      <div
                        key={example}
                        className="flex items-start gap-2 text-sm text-tie-text-secondary"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-tie-teal shrink-0 mt-1.5" />
                        {example}
                      </div>
                    ))}
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}